import { render, staticRenderFns } from "./ConsumosWrapper.vue?vue&type=template&id=43821d3f&scoped=true"
import script from "./ConsumosWrapper.vue?vue&type=script&lang=js"
export * from "./ConsumosWrapper.vue?vue&type=script&lang=js"
import style0 from "./ConsumosWrapper.vue?vue&type=style&index=0&id=43821d3f&prod&lang=scss&scoped=true"
import style1 from "./ConsumosWrapper.vue?vue&type=style&index=1&id=43821d3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43821d3f",
  null
  
)

export default component.exports